import { api1C } from './api';

export const get1cStocks = (params) =>
    api1C.get('stocks', {
        params,
    });
